import { Link } from 'react-router-dom';

export function Footer() {
  const productLinks = [
    { name: 'Flaggen', href: '/flaggen' },
    { name: 'Werbung', href: '/werbung' },
    { name: 'Promotion', href: '/promotion' }
  ];

  const companyLinks = [
    { name: 'Über uns', href: '/ueber-uns' },
    { name: 'Qualität', href: '/ueber-uns#qualitaet' },
    { name: 'Kontakt', href: '/kontakt' }
  ];

  const serviceLinks = [
    { name: 'Anfrage stellen', href: '/kontakt' },
    { name: 'Beratung', href: '/kontakt' },
    { name: 'Lieferung', href: '/ueber-uns#lieferung' }
  ];

  return (
    <footer className="bg-zinc-900 text-white">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 lg:gap-12">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <div className="mb-6">
              <h3 className="text-3xl font-bold tracking-tight">
                HORIZON SIGNAGE
              </h3>
            </div>
            <p className="text-gray-400 text-lg leading-relaxed mb-8 max-w-md">
              Ihr Partner für professionelle Promotion-Fahnen und visuelle Außenwerbung. 
              Hochwertige Qualität für starke Markenauftritte.
            </p>
            <div className="space-y-3 mb-8">
              <div className="flex items-center text-gray-400">
                <i className="ri-phone-line mr-3 text-lg"></i>
                <a href="tel:+4917296060061" className="hover:text-white transition-colors">
                  +49 172 9606061
                </a>
              </div>
              <div className="flex items-center text-gray-400">
                <i className="ri-mail-line mr-3 text-lg"></i>
                <a href="mailto:info@horizonsignage.de" className="hover:text-white transition-colors">
                  info@horizonsignage.de
                </a>
              </div>
              <div className="flex items-start text-gray-400">
                <i className="ri-map-pin-line mr-3 text-lg mt-1"></i>
                <span>Speditionstrasse 15a, 40221 Düsseldorf</span>
              </div>
            </div>
            <div className="flex space-x-4">
              <a
                href="#"
                className="w-10 h-10 flex items-center justify-center rounded-full border border-gray-600 text-gray-400 hover:text-white hover:border-white transition-colors"
              >
                <i className="ri-linkedin-line text-lg"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 flex items-center justify-center rounded-full border border-gray-600 text-gray-400 hover:text-white hover:border-white transition-colors"
              >
                <i className="ri-facebook-line text-lg"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 flex items-center justify-center rounded-full border border-gray-600 text-gray-400 hover:text-white hover:border-white transition-colors"
              >
                <i className="ri-instagram-line text-lg"></i>
              </a>
            </div>
          </div>

          {/* Products */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider mb-6">
              PRODUKTE
            </h4>
            <ul className="space-y-3">
              {productLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    className="text-gray-400 hover:text-white transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider mb-6">
              UNTERNEHMEN
            </h4>
            <ul className="space-y-3">
              {companyLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    className="text-gray-400 hover:text-white transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Service */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider mb-6">
              SERVICE
            </h4>
            <ul className="space-y-3">
              {serviceLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    className="text-gray-400 hover:text-white transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Footer */}
      <div className="border-t border-gray-800">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6">
          <div className="mt-8 pt-8 border-t border-gray-200 flex flex-col md:flex-row justify-between items-center">
            <p className="text-sm text-gray-500">
              © 2024 Horizon Signage. Alle Rechte vorbehalten.
            </p>
            <div className="mt-4 md:mt-0 flex items-center space-x-4">
              <Link to="/impressum" className="text-sm text-gray-500 hover:text-[#254a29]">
                Impressum
              </Link>
              <Link to="/datenschutz" className="text-sm text-gray-500 hover:text-[#254a29]">
                Datenschutz
              </Link>
              <a 
                href="https://cdco.com.tr" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-sm text-gray-500 hover:text-[#254a29]"
              >
                Powered by CDCO
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
